import log from 'loglevel';
const defaultLevel = location.hostname === 'localhost' ? 'debug' : 'info';
log.setDefaultLevel(defaultLevel);
export { log };
export type { LogLevelDesc } from 'loglevel';
